import { GlobalResponseObject, Series } from '@gtpl/shared-models/common-models';
import {ChartInfo} from '@gtpl/shared-models/production-management'
export class PackingRequiredResponse extends GlobalResponseObject{
    data?: ChartInfo;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //LotCodeDropDown
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: ChartInfo) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
